import React, { PureComponent, Fragment } from 'react';
import { Col, Container, Row,  Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import { withOktaAuth } from '@okta/okta-react';
import { setUserProfile } from '../../redux/actions/authActions';

import SubscriptionForm from './components/SubscriptionForm';
import BillingForm from './components/BillingForm';
import DataUsage from './components/DataUsage';
import Invoices from './components/Invoices';
import Receipts from './components/Receipts';

import CustomSubscription from './components/CustomSubscription';
import AutoRechargeSettings from '../../shared/components/premium_credits/AutoRechargeSettings';

import BuyerAgentIcon from 'mdi-react/AccountOutlineIcon';
import SalesGalleryIcon from 'mdi-react/FloorPlanIcon';
import MediaIcon from 'mdi-react/BullhornOutlineIcon';
import EnterpriseIcon from 'mdi-react/DomainIcon';

import showResults from './Show';

import SnackBar from '../../shared/components/SimpleSnackBar';

import TrialAlert from '../../shared/components/payment/TrialAlert';

import QuickStartGuide from '../../shared/components/QuickStartGuide';
import StripeCardSetupModal from '../../shared/components/payment/stripe/StripeCardSetupModal';
import AlertIcon from 'mdi-react/StarFourPointsOutlineIcon';
import Alert from '../../shared/components/Alert';
import { _hasPermission	} from "../../shared/helpers/access";
import Button from '@material-ui/core/Button';
import { Tooltip } from '@material-ui/core';
import CCIcon from 'mdi-react/CreditCardIcon';


import PremiumCreditsPurchaseModal from '../../shared/components/premium_credits/PremiumCreditsPurchaseModal';


import{
	_capitalizeText,
} from '../../shared/helpers/utils';
import{
	_axiosCall
} from '../../shared/helpers/apicalls';
const oktaToken = process.env.OKTA_TOKEN;

const apiUrl = process.env.API_ROOT + '/buyerslist/';
//const apiUrl = 'http://localhost:8000/buyerslist/';

//const apiUrl = 'https://newsapi.we3.com/buyerslist/'

class BillingProfile extends PureComponent {
	constructor(props) {
	    super(props);
	    this.state = {
	      fetchInProgress: false,
	      snackShow: false,
	      snackMessage: false,
	      snackType: 'success',
	      customer: false,
	      subscription: false,
	      paymentMethod: false,
	      invoices:false,
	      refresh:false,
	      userCreditUsed: false,
	      customSubscription: false,
		  coupon: false,
		  subscriptionSchedule:false,
		  setupClientSecret: null,
		  showPaymentModal: false
	    };
	    this.updateUser = this.updateUser.bind(this);
	    this._cancelSubscription = this._cancelSubscription.bind(this);
	    	
	    this.snackOpen = this.snackOpen.bind(this);
	    this.snackClose = this.snackClose.bind(this);
	    this._getSubscriptionDetails = this._getSubscriptionDetails.bind(this);
	    this.toggleRefresh = this.toggleRefresh.bind(this);
	    this._getUserCredits = this._getUserCredits.bind(this);
		this.setCoupon = this.setCoupon.bind(this);
		this._updateSubscriptionDetails = this._updateSubscriptionDetails.bind(this);
		this._releaseSubscriptionSchedule = this._releaseSubscriptionSchedule.bind(this);
	    
	}
	  
    componentDidMount(){
	  const { authState, authService, dispatch, user } = this.props;
	  console.log(authState);
	  this._getSubscriptionDetails();
    }
    componentDidUpdate(prevProps, prevState) {
	    
	    const { user } = this.props;
	    
	    if(prevState.refresh !== this.state.refresh ||
	   		 (prevProps.user.subscriptionStatus !== user.subscriptionStatus) ||
	   		 (prevProps.user.subscriptionPlan !== user.subscriptionPlan)){
		     this._getSubscriptionDetails();

	    }
	    
	}
    updateUser(values) {
	    console.log(values);
	    this._updateUserProfile(values);
	  
	}
	
	toggleRefresh = () => {
    	this.setState(prevState => ({ refresh: !prevState.refresh }));;
    };
	
	snackOpen = (message, type) => {
    	this.setState( { snackShow: true, snackMessage: message, snackType : type} )
    };

    snackClose = (event, reason) => {
	    if (reason === 'clickaway') {
	      return;
	    }	
	    this.setState( { snackShow: false, snackMessage: ''} )
	};
	
	_checkIfCustomerHasCard(customerId) {
	  _axiosCall({
		url: apiUrl + '/stripe/get-payment-methods',
		method: 'post',
		query: {
		  customer_id: customerId
		}
	  }).then((res) => {
		if (res && res.success && res.methods && res.methods.length > 0) {
		  this.setState({ paymentMethod: res.methods[0] }, () => {
		  });
		} 
	  }).catch((err) => {
		console.error('Error checking payment methods:', err);
		
	  });
	}
	
	_createSetupIntent = (customerId) => {
	  _axiosCall({
		url: apiUrl + 'stripe/create-setup-intent',
		method: 'post',
		query: {
		  customer_id: customerId
		}
	  }).then((res) => {
		if (res && res.client_secret) {
		  this.setState({
			setupClientSecret: res.client_secret,
			showPaymentModal: true
		  });
		} else {
		  this.snackOpen('Failed to initiate payment setup.', 'error');
		}
	  }).catch((err) => {
		console.error('Failed to create SetupIntent:', err);
		this.snackOpen('Payment setup failed. Try again.', 'error');
	  });
	};
	
	_createCustomerAndAddCard = () => {
	  const { user, dispatch } = this.props;
	
	  // ✅ Already has a Stripe customer, just start SetupIntent
	  if (user.customerId) {
		this._createSetupIntent(user.customerId);
		return;
	  }
	
	  // ❌ No Stripe customer — create one
	  this.setState({ fetchInProgress: true });
	
	  _axiosCall({
		url: apiUrl + 'stripe/create-basic-customer',
		method: 'post',
		query: {
		  userId: user.id,
		  name: `${user.firstName || ''} ${user.lastName || ''}`.trim(),
		  email: user.email
		}
	  }).then((res) => {
		if (res && res.customerId) {
		  const updatedUser = {
			user_key: user.id,
			email: user.email,
			customerId: res.customerId,
			updated_timestamp: new Date()
		  };
		  dispatch(setUserProfile({ ...user, customerId: res.customerId }));
		  this._createSetupIntent(res.customerId);
		} else {
		  this.snackOpen('Could not create customer. Please try again.', 'error');
		}
	  }).catch((err) => {
		console.error('Customer creation failed:', err);
		this.snackOpen('Error creating customer. Please try again.', 'error');
	  }).finally(() => {
		this.setState({ fetchInProgress: false });
	  });
	};



	
	_getSubscriptionDetails = () => {
     // console.log('_getBuildingData called', this.state)
           
      const { authState, authService, dispatch, user } = this.props;	  	  
 
	  const { subscriptionId } = user;
	  
	  if(!subscriptionId) return false;
	  /**User without a subscripton - prepaid or custom plan**/
	  if (user.downloadAccess === 'manual') {
		const date = new Date(), y = date.getFullYear(), m = date.getMonth();
		const firstDay = Math.floor(new Date(y, m, 1).getTime() / 1000);
		const lastDay = Math.floor(new Date(y, m + 1, 0).getTime() / 1000);
		const subscription = {
		  current_period_start: firstDay,
		  current_period_end: lastDay
		};
	  
		this._getUserCredits(subscription);
	  
		if (user.customerId) {
		  _axiosCall({
			url: apiUrl + 'stripe/get-customer',
			method: 'post',
			query: {
			  customer_id: user.customerId
			}
		  }).then((res) => {
			this.setState({
			  customer: res && res.customer ? res.customer : user,
			  subscription: {},
			  paymentMethod: {},
			  customSubscription: true
			});
	  
			if (res && res.customer && res.customer.id) {
			  this._checkIfCustomerHasCard(res.customer.id);
			}
		  }).catch((err) => {
			console.error('Failed to fetch Stripe customer:', err);
			this.setState({
			  customer: user,
			  subscription: {},
			  paymentMethod: {},
			  customSubscription: true
			});
		  });
		} else {
		  this.setState({
			customer: user,
			subscription: {},
			paymentMethod: {},
			customSubscription: true
		  });
		}
	  
		return false;
	  }

	   /**User without a subscripton - prepaid or custom plan**/

	  let userData = {
			url: apiUrl+'stripe/get-subscription',
			method: "post",
			query: {
				subscription_id: subscriptionId
			}
	  };
	  
	  
	  _axiosCall(userData)
	    .then(res => {
	      console.log("_getUserData res back ,", res);
	      
	      if(res && res.customer){	
		      this._getUserCredits(res.subscription);
		      this.setState(
			      {
				      customer: res.customer,
				      subscription: res.subscription,
				      paymentMethod: res.paymentMethod,
					  subscriptionSchedule: res.subscriptionSchedule ? res.subscriptionSchedule : false
			      }
		      )
		      
		      
		  }else{
			  this.setState({
				  customer: user,
			      subscription: {},
			      paymentMethod: {},
				  subscriptionSchedule: false
		      });		  
						  
		  }
	  })
	  .catch((error) => {
	    console.log("_getUserData error ", error);
	  });

	}
	_updateSubscriptionDetails = (couponResult) => {
	  
	  const { changePlan, user } = this.props;
	  const { subscriptionId } = user;
	  const { subscription, coupon } = this.state;
	  
	  
	  if(!subscriptionId) return false;
	  
	  
	  if(this.state.fetchInProgress) return false;
	  
	  this.setState({fetchInProgress : true});
	
	  let userData = {
			url: apiUrl+'stripe/update-subscription',
			method: "post",
			query: {
				subscription_id: subscriptionId,
				subscriptionData: {
				  coupon : couponResult && couponResult.id ? coupon.id : ''
				}
			}
	  };
	 
		
	  _axiosCall(userData)
		.then(res => {
		  console.log("_getUserData res back ,", res);
		  
		  if(res && res.subscription && res.subscription.id){	
			 
			 this.setState(
				   {
					   
					   subscription: res.subscription,
				   }
			   )
			  
		  }else{
			 if(res && res.message){
				this.snackOpen(<Fragment><span>Oops, your subscription was not updated. <p className="small-text light-text" style={{ marginLeft:'30px', color:'#FFF' }}>{_capitalizeText(res.message)}</p></span></Fragment>, 'error');
			 }else{
				this.snackOpen('Oops, something went wrong, your subscription was not activated.', 'error');
			 }		  
		  }
	  })
	  .catch((error) => {
		console.log("_getUserData error ", error);
	  });
	
	
	}
	_releaseSubscriptionSchedule = () => {
	  
	  const { changePlan, user } = this.props;
	  const { subscriptionId } = user;
	  const { subscriptionSchedule, coupon } = this.state;
	  
	  
	  if(!subscriptionSchedule) return false;
	  
	  
	  if(this.state.fetchInProgress) return false;
	  
	  this.setState({fetchInProgress : true});
	
	  let userData = {
			url: apiUrl+'stripe/release-subscription-schedule',
			method: "post",
			query: {
				subscription_schedule_id: subscriptionSchedule.id,
				
			}
	  };
	 
		
	  _axiosCall(userData)
		.then(res => {
		  console.log("_getUserData res back ,", res);
		  
		  if(res && res.id){	
			 
			 this.setState(
				   {
					   
					   subscriptionSchedule: false
				   }
			   )
			  
		  }else{
			 if(res && res.message){
				this.snackOpen(<Fragment><span>Oops, your subscription was not updated. <p className="small-text light-text" style={{ marginLeft:'30px', color:'#FFF' }}>{_capitalizeText(res.message)}</p></span></Fragment>, 'error');
			 }else{
				this.snackOpen('Oops, something went wrong, your subscription was not activated.', 'error');
			 }		  
		  }
	  })
	  .catch((error) => {
		console.log("_getUserData error ", error);
	  });
	
	
	}
	setCoupon(coupon) {
	   this.setState( {coupon: coupon} )
	}
	
	_getUserCredits = (subscription) => {
		
	  const { id } = this.props.user;
	  let userData = {
			url: process.env.API_ROOT+'/dataexport/analytics/aggregate',
			method: "post",
			query: [
				    {
				        "$match": {
				            "$and" :[
				                { "user_key" : id },
				                { "created_timestamp_unix" : {
				                    "$gte" : subscription.current_period_start,
				                    "$lt" : subscription.current_period_end
				                }}
				            ]           
				        }
				    },
				    {
				        "$group" : {
				            "_id" : null,
				            "total" : {
				                "$sum" : "$credits"
				            }
				        }
				    }
				]
			
	  };
	  	  
	  _axiosCall(userData)
	    .then(res => {
	      console.log("_getUserData res back ,", res);
	      if(res && res.length>0 && res[0].total){	
	        this.setState({userCreditUsed:res[0].total})	      
		  }else{
			this.setState({userCreditUsed:0})		  
		  }
	  })
	  .catch((error) => {
	    console.log("_getUserData error ", error);
	  });
	
	
  }
	
	_updateUserProfile= (values) => {
     // console.log('_getBuildingData called', this.state)           
      const { authState, authService, dispatch, user } = this.props;	  	  
      let headers = {
		  "Authorization" : `SSWS ${oktaToken}`,
	  }
	  
	  let profile = Object.assign({}, user, values);
	  const user_id = profile.id;
	  if(profile.id) delete profile.id
	  if(profile.login) delete profile.login
	  if(profile.role) delete profile.role
	 	  
	  let userData = {
			url: apiUrl+'user/update',
			method: "post",
			query: {
				id: user_id,
				profile: profile
			}
	  };  
	  _axiosCall(userData)
	    .then(res => {
	      console.log("_getUserData res back ,", res);
	      
	      if(res && res.profile){
			  let oktaUser = Object.assign({}, res.profile);
			  oktaUser['id']= res.id;
		      dispatch(setUserProfile(oktaUser));
		      this.snackOpen('Your Subscription Has Been Cancelled.', 'success');
		  }else{
			  if(res.message){
				this.snackOpen('Oops, Something Went Wrong, Your Subscription Was Not Cancelled.', 'error'); 
			 }else{
				this.snackOpen('Oops, Something Went Wrong, Your Subscription Was Not Cancelled.', 'error'); 
			 }
			  
		  }
	  })
	  .catch(error => {
	    console.log("_getUserData error ", error);
	   this.snackOpen('Oops, Something Went Wrong, Your Subscription Was Not Cancelled.', 'error'); 
	  });
	}
	
	
	_cancelSubscription = (subscription) => {
     // console.log('_getBuildingData called', this.state)
           
      const { authState, authService, dispatch, user } = this.props;	  	  
 
	  const { subscriptionId } = user;
	  
	  if(!subscriptionId) return false;
	  
	  
	  let cancelEndPoint = subscription.status === 'trialing' || !subscription.current_period_end ? 'stripe/cancel-subscription' : 'stripe/cancel-subscription-period-end';

	  let userData = {
			url: apiUrl+cancelEndPoint,
			method: "post",
			query: {
				subscription_id: subscriptionId,
				user: user,
				current_period_end: subscription && subscription.current_period_end ? subscription.current_period_end : false
			}
	  };
	  
	  
	  _axiosCall(userData)
	    .then(res => {
	      console.log("_getUserData res back ,", res);
	      
	      if(res && res.status && res.status === 'canceled'){	
		      
		      
		       this.snackOpen('Your subscription has been cancelled.');

		       setTimeout(function(){  
			       let oktaUser = Object.assign({}, res.profile);
				   oktaUser['id']= res.id;
				   dispatch(setUserProfile(oktaUser));			      
			  }.bind(this), 3000);

		            
		      
		  }else if(res && res.status && res.status === 'active' && res.cancel_at_period_end){
			  this.snackOpen('Your subscription has been cancelled.');	
			  this.toggleRefresh();	  			  
		  }else{			  
			 if(res.message){
				this.snackOpen('Oops, Something Went Wrong, Your Subscription Was Not Cancelled.', 'error'); 
			 }else{
				this.snackOpen('Oops, Something Went Wrong, Your Subscription Was Not Cancelled.', 'error'); 
			 }
			  
		  }
	  })
	  .catch((error) => {
	    console.log("_getUserData error ", error);
	    this.snackOpen('Oops, Something Went Wrong, Your Subscription Was Not Cancelled.', 'error');
	  });

	}
	
	_reactivateSubscription = (subscription) => {
     // console.log('_getBuildingData called', this.state)
           
      const { authState, authService, dispatch, user } = this.props;	  	  
 
	  const { subscriptionId } = user;
	  
	  if(!subscriptionId) return false;
	  
	  
	  let cancelEndPoint = 'stripe/reactivate-subscription';

	  let userData = {
			url: apiUrl+cancelEndPoint,
			method: "post",
			query: {
				subscription_id: subscriptionId,
				user: user,
			}
	  };
	  
	  
	  _axiosCall(userData)
	    .then(res => {
	      console.log("_getUserData res back ,", res);
	      
	      if(res && res.status && res.status === 'active'){			      
		      
		       this.snackOpen('Your subscription has been reactivated!');
		       this.toggleRefresh();	  			  
     		      
		  }else{			  
			 if(res.message){
				this.snackOpen('Oops, Something Went Wrong, Your Subscription Was Not Reactivated.', 'error'); 
			 }else{
				this.snackOpen('Oops, Something Went Wrong, Your Subscription Was Not Reactivated.', 'error'); 
			 }
			  
		  }
	  })
	  .catch((error) => {
	    console.log("_getUserData error ", error);
	    this.snackOpen('Oops, Something Went Wrong, Your Subscription Was Not Reactivated.', 'error');
	  });

	}
	
	 setAccountType = (type) => {   

		 const { authState, authService, dispatch, user } = this.props;	  	  
	      let headers = {
			  "Authorization" : `SSWS ${oktaToken}`,
		  }
		  
		  let profile = Object.assign({}, user, {accountType:type});
		  const user_id = profile.id;
		  if(profile.id) delete profile.id
		  if(profile.login) delete profile.login
		  if(profile.role) delete profile.role
		 	  
		  let userData = {
				url: apiUrl+'user/update',
				method: "post",
				query: {
					id: user_id,
					profile: profile
				}
		  };  
		  _axiosCall(userData)
		    .then(res => {
		      console.log("_getUserData res back ,", res);
		      
		      if(res && res.profile){
				  let oktaUser = Object.assign({}, res.profile);
				  oktaUser['id']= res.id;
			      dispatch(setUserProfile(oktaUser));
			      this.snackOpen('Your Account Type Has Been Changed.', 'success');
			  }else{
				  if(res.message){
					this.snackOpen('Oops, Something Went Wrong, Your Account Type Could Not Be Changed.', 'error'); 
				 }else{
					this.snackOpen('Oops, Something Went Wrong, Your Account Type Could Not Be Changed.', 'error'); 
				 }
				  
			  }
		  })
		  .catch(error => {
		    console.log("_getUserData error ", error);
		   this.snackOpen('Oops, Something Went Wrong, Your Subscription Was Not Cancelled.', 'error'); 
		  });
	  };

	
	
	render(){
		const { snackShow, snackMessage, snackType, subscription, customer, paymentMethod, invoices, userCreditUsed, coupon, subscriptionSchedule } = this.state;
		const { user } = this.props;
		if(!paymentMethod) return false;
		return (
			<Container className="billing">
				<SnackBar 
					snackShow={snackShow} 
					snackMessage={snackMessage} 
					snackClose={this.snackClose} 
					snackDuration={5000} 
					snackType={snackType} 
				/>
				{this.state.showPaymentModal &&
				  <StripeCardSetupModal
					isOpen={this.state.showPaymentModal}
					clientSecret={this.state.setupClientSecret}
					user={user}
					onClose={() => this.setState({ showPaymentModal: false })}
					onComplete={() => {
					  this.setState({ showPaymentModal: false }, () => {
						this._checkIfCustomerHasCard(user.customerId);
					  });
					}}
				  />
				}

			    <Row>
			      <Col md={12}>
			        <h3 className="page-title">{`Subscription & Billing`}</h3>
			        <h3 className="page-subhead subhead">Update your subscription information</h3>
			      </Col>
			    </Row>
				<QuickStartGuide link={"https://help.marketproof.com/en/articles/10553215-my-account"} type={"Subscription & Billing"} />

			    <Row>
			      <Col md={12} className={'mb-3'}>
			       	<TrialAlert />        
			      </Col>
			    </Row>
				{_hasPermission(user, "elliman-notices") ?
				<Row>
					<Col md={12} className={'mb-4'}>
						<Alert color="success" noClose={true} className="alert--bordered"  alertId="douglasEllimanCredits" icon iconItem={<AlertIcon />} minimizeText={`Credits for Douglas Elliman Agents`}>
						  <p>
							  <span className="bold-text">{`Notice for Douglas Elliman Agents`}</span> 
							<div>{`Your Marketproof Pro subscription includes 25 monthly credits, courtesy of Douglas Elliman. If you need more, you can purchase additional credits directly. Please ensure you have a credit card on file—charges will apply when extra credits are needed, and costs are your responsibility.`}</div>
						  </p>
						</Alert>
					</Col>
				</Row>:null}
			    
			    {user && user.subscriptionId &&
					<Row>				      
				      {(!user.subscriptionHierarchy || user.subscriptionHierarchy != 'child') && (
						!customer || !paymentMethod || !paymentMethod.id ? (
						  <Col md={12} lg={6}>
						  	<Card className="mb-4"  className="billing">
								<CardBody>
								<div className="card__title">
								  <h5 className="bold-text"><CCIcon size={36} /> {'Add a Payment Method'}</h5>
								  <div className="page-subhead subhead"></div>
								  <hr/>
								</div>	
							  	
							  	<p className="mb-3">{_hasPermission(user, "elliman-notices") ? "To purchase credits beyond those included in your Douglas Elliman Corporate Plan, please add a credit card." : "To enable billing features, please add a credit card."}</p>
							  	
								  <Tooltip title="Add a Credit Card">
									  <Button
										   onClick={this._createCustomerAndAddCard}
										   variant="contained"
										   color="primary"
										   className="buyersList__primary-button"	
										   disabled={this.state.fetchInProgress}	         
										   startIcon={<CCIcon />}
									   >	Add Credit Card
									   </Button>				 
									</Tooltip>
								</CardBody>
						  	</Card>
						  </Col>
						) : (
						  <BillingForm
							{...this.props}
							customer={customer}
							subscription={subscription}
							paymentMethod={paymentMethod}
							snackOpen={this.snackOpen}
							toggleRefresh={this.toggleRefresh}
						  />
						)
					  )}

				      {(!user.subscriptionHierarchy || user.subscriptionHierarchy != 'child') ?
					      <SubscriptionForm {...this.props} 
					      	customer={customer} 
					      	subscription={subscription} 
							subscriptionSchedule={subscriptionSchedule}
					      	cancelSubscription={this._cancelSubscription} 
					      	reactivateSubscription={this._reactivateSubscription} 
					      	userCreditUsed={userCreditUsed}
							setCoupon={this.setCoupon}
							coupon={coupon}
							updateSubscriptionDetails={this._updateSubscriptionDetails}
							releaseSubscriptionSchedule={this._releaseSubscriptionSchedule}
					      	/>
					      	:
					    	<CustomSubscription />
				      	}
				      	{(!user.downloadAccess || user.downloadAccess != "disabled") &&
					      	<DataUsage {...this.props} userCreditUsed={userCreditUsed} message={_hasPermission(user, "elliman-notices") ? "Credits Used This Period (25 monthly credits included with your Douglas Elliman Corporate Plan)" : false} />
				      	}



				    </Row>
			    }
				<Row>
					
				</Row>
			     
			    {(!user.subscriptionHierarchy || user.subscriptionHierarchy != 'child') &&
				<Row>
			      <Receipts user={user} customerId={customer && customer.id ? customer.id : user.customerId} />
			      <Invoices user={user} customerId={customer && customer.id ? customer.id : user.customerId} />
				  </Row>
			    }				      
				
			    

			</Container>
		);	
	}
  
};

export default connect(state => ({
  user: state.user,
}))(withOktaAuth(BillingProfile));
